import { combineReducers } from 'redux';
import actionsReducer, { ActionsState } from './actions';
import documentationFileListsReducer, {
  DocumentationFileListsState,
} from './documentationFileLists';
import menteeListsReducer, { MenteeListsState } from './menteeLists';
import mentorListsReducer, { MentorListsState } from './mentorLists';

export type AdminStoreState = {
  menteeLists: MenteeListsState;
  mentorLists: MentorListsState;
  actions: ActionsState;
  documentationFileLists: DocumentationFileListsState;
};

const adminReducer = combineReducers({
  menteeLists: menteeListsReducer,
  mentorLists: mentorListsReducer,
  actions: actionsReducer,
  documentationFileLists: documentationFileListsReducer,
});

export default adminReducer;
